angular.module('angus.directives').directive('taskbar', [
    function() {
        return {
            templateUrl: 'templates/authenticated/layout/taskbar/taskbar.html'
        };
    }
]);